const supervisorRoutes = {
  dashboardSupervisor: {
    path: '/dashboard/supervisor'
  },
  supervisorProfile: {
    path: '/supervisor/profile'
  },
  listSupervisor: {
    path: '/users/supervisors'
  },
  createSupervisor: {
    path: '/users/supervisors/create'
  },
  editSupervisor: {
    path: '/users/supervisors/edit/:id'
  }
};

export default supervisorRoutes;
